import * as t from '../types';
import {DeleteContentNote} from '../../services'


export const deleteContentNoteAction = (id) => async (dispatch) => {
    dispatch({
        type: t.DELETE_CONTENT_NOTE_REQUEST
    });

    return await DeleteContentNote(id)

        .then((data) => {
            dispatch({
                type: t.DELETE_CONTENT_NOTE_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            dispatch({
                type: t.DELETE_CONTENT_NOTE_FAILED,
                payload: err.response
            });
        });
};
